import { TransformControls } from "@react-three/drei";
import React, { useRef } from "react";
import CustomDragHandles from "./CustomDragHandles";
import CustomScaleHandles from "./CustomScaleHandles";

import { createGeometry } from "./utils";
import {
  useUpdateMesh,
  useUpdateMeshState,
  useSetupTransformControls,
  useHide4thRotationCircle,
  useTriggereRerender,
  useSetupMouseRotation,
} from "./hooks";
import { colors } from "../../utils/colors";

function AdjustableShape({
  transformMode,
  transformAxis,
  position,
  rotation = [0, 0, 0],
  scale = [1, 1, 1],
  onPositionChange,
  selectedShape = "cube",
  shapeParams = [2, 10, 5],
}) {
  const transformRef = useRef();
  const meshRef = useRef();

  useUpdateMesh(meshRef, position, rotation, scale);
  useUpdateMeshState(meshRef);
  useSetupTransformControls(
    meshRef,
    transformRef,
    transformMode,
    transformAxis
  );
  useHide4thRotationCircle(transformRef);
  useTriggereRerender(meshRef, selectedShape);
  useSetupMouseRotation(meshRef, transformMode, transformAxis);

  return (
    <group>
      {transformMode === "drag" && (
        <CustomDragHandles
          position={position}
          onPositionChange={onPositionChange}
          meshRef={meshRef}
        />
      )}

      {transformMode === "scale" && (
        <CustomScaleHandles position={position} meshRef={meshRef} />
      )}

      {transformMode === "rotate" && transformAxis === "xyz" && (
        <TransformControls
          ref={transformRef}
          size={1}
          space="world"
          mode="rotate"
        />
      )}

      <mesh ref={meshRef} position={position}>
        {createGeometry(selectedShape, shapeParams)}
        <meshStandardMaterial color={colors.orange500()} />
      </mesh>
    </group>
  );
}

export default AdjustableShape;
